import React from "react";

const ITEMS = [
  {
    key: "snacks",
    title: "Healthy Snacks",
    sub: "True to your identity",
    body: "Nourishing your identity with every bite — wholesome ingredients inspired by global cuisines.",
    img: "https://images.pexels.com/photos/11091172/pexels-photo-11091172.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    key: "appetizers",
    title: "Appetizers",
    sub: "With cultural roots",
    body: "Perfect for any occasion — traditional flavours with a modern twist.",
    img: "https://images.unsplash.com/photo-1594489883219-010b0e5eeb9d?auto=format&fit=crop&w=1600&q=80",
    span: "lg:col-span-5",
  },
  {
    key: "barbites",
    title: "Bar Bites",
    sub: "That bring people together",
    body: "Bold, flavourful, and made to elevate every gathering.",
    img: "https://images.unsplash.com/photo-1734987942068-a1a459d65d3d?auto=format&fit=crop&w=1600&q=80",
    span: "lg:col-span-5",
  },
  {
    key: "mains",
    title: "Main Courses",
    sub: "That complete the experience",
    body: "Hearty, authentic meals rooted in cultural tradition.",
    img: "https://images.pexels.com/photos/6107772/pexels-photo-6107772.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
    span: "lg:col-span-7",
  },
];

export const WhatToExpect = () => {
  return (
    <section
      id="expect"
      data-testid="what-to-expect-section"
      className="relative bg-stone-950 py-24 sm:py-32 lg:py-40 border-t border-stone-900"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 items-end">
          <div className="lg:col-span-5">
            <p className="text-orange-500 font-sans-display text-xs uppercase tracking-[0.32em] mb-6">
              02 — What to Expect
            </p>
            <h2
              className="font-serif-display text-stone-50 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
              data-testid="expect-heading"
            >
              Four kitchens.
              <br />
              <em className="not-italic text-stone-400">One identity.</em>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-stone-300 font-sans-display text-base sm:text-lg leading-relaxed">
              Every menu is built to move with you — through quiet weeknights,
              loud weekends, and the moments that demand something memorable.
              We&apos;ve organised what&apos;s coming into four pillars, each
              with its own voice and its own soul.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 lg:auto-rows-[18rem] gap-6">
          {ITEMS.map((item, i) => (
            <article
              key={item.key}
              data-testid={`expect-card-${item.key}`}
              className={`bento-card group relative ${item.span} bg-stone-900 min-h-[20rem] lg:min-h-0`}
            >
              <img
                src={item.img}
                alt={item.title}
                className="bento-img absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/30 to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-stone-800/60 group-hover:ring-orange-500/40 transition-colors" />
              <div className="relative h-full w-full flex flex-col justify-end p-8 lg:p-10">
                <span className="font-sans-display text-[10px] uppercase tracking-[0.32em] text-orange-500 mb-3">
                  0{i + 1}
                </span>
                <h3 className="font-serif-display text-stone-50 text-3xl lg:text-4xl leading-tight">
                  {item.title}
                </h3>
                <p className="font-serif-display italic text-stone-400 text-lg mt-1">
                  {item.sub}
                </p>
                <p className="font-sans-display text-stone-300 text-sm mt-4 max-w-md leading-relaxed">
                  {item.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatToExpect;
